import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import GoogleAutocomplete from "./GoogleAutoComplete";
import SearchFilter from "./SearchFilter";
import { useTranslation } from "react-i18next";
import "react-day-picker/dist/style.css";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";


const HotelAdminFilter = ({ body, setBody, searchHandler, type, setFinanceStatus, setFinanceSearch }) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState(body.search || "");

const [range, setRange] = useState({
  from: body.startDate ? new Date(body.startDate) : undefined,
  to: body.endDate ? new Date(body.endDate) : undefined,
});

const [showCalendar, setShowCalendar] = useState(false);
const toUTCDateString = (date) => {
  if (!date) return "";

  const utcDate = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );

  return format(utcDate, "yyyy-MM-dd");
};

const handleRangeSelect = (selectedRange) => {
  setRange(selectedRange);

  setBody((prev) => ({
    ...prev,
    startDate: selectedRange?.from
      ? new Date(selectedRange.from).toISOString()
      : "",
    endDate: selectedRange?.to
      ? new Date(selectedRange.to).toISOString()
      : "",
    page: 1,
  }));
};
  const [debouncedAddress, setDebouncedAddress] = useState(body.address || "");
  useEffect(() => {
    const handler = setTimeout(() => {
      if (debouncedAddress !== body.address) {
        setBody((prev) => ({
          ...prev,
          address: debouncedAddress,
          lat: prev.lat,
          lng: prev.lng,
          page: 1,
        }));
      }
    }, 500);
    return () => clearTimeout(handler);
  }, [debouncedAddress]);

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, status: value, page: 1 }));
    setFinanceStatus && setFinanceStatus(value?.toLocaleLowerCase());
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, country: value, page: 1 }));
  };

  const handleRegionChange = (data) => {
    setDebouncedAddress(data.address || "");
    setBody((prev) => ({
      ...prev,
      lat: data.lat || "",
      lng: data.lng || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSearchValue("");
    setDebouncedAddress("");
    setBody((prev) => ({
      ...prev,
      status: "",
      address: "",
      country: "",
      search: "",
      lat: "",
      lng: "",
      page: 1,
    }));
    setFinanceSearch && setFinanceSearch("");
    setFinanceStatus && setFinanceStatus("");
 setRange({ from: undefined, to: undefined });
  };

  // 👇 Dynamic status options
  const getStatusOptions = () => {
    if (type === "transaction") {
      // return ["Success", "Pending", "Failed"];
      // return ['Expired', 'Completed', 'Cancelled'];
      return ['Pending', 'Confirmed', 'Checked in', 'Checked out', 'Cancelled', 'Expired', 'Completed']
    } else if (type === "upcomingBooking") {
      return ['Pending', 'Confirmed', 'Checked in', 'Cancellation Requested', 'Cancelled', 'Expired', 'Completed'];
    } else if (type === "bookingHistory") {
      return  ['Pending', 'Confirmed', 'Checked in', 'Cancellation Requested', 'Cancelled', 'Expired', 'Completed'];
    } else if (type === "coupon") {
      return ["Active", "Inactive", "Expired"];
    } else if (type === "finance") {
      return ["Pending", "Success", "Completed", "Rejected"];
    } else {
      return ["Active", "Inactive", "Blocked"];
    }
  };

  return (
    <div className="bg-white rounded-3  mb-3" style={{ fontSize: "14px" }}>
      <div
        className="d-flex flex-wrap align-items-end gap-2"
        style={{
          rowGap: "10px",
          columnGap: "15px",
        }}
      >
        {/* Status */}
        <div style={{ minWidth: 150 }}>
          <Form.Label className="fw-semibold text-muted mb-1 d-block">
            {t("common.status")}
          </Form.Label>
          <Form.Select
            size="sm"
            value={body.status || ""}
            onChange={handleStatusChange}
            className="shadow-sm"
            style={{ height: "40px" }}
          >
            <option value="">All</option>
            {getStatusOptions().map((status) => (
              <option key={status} value={!type || type === "transaction"||type==="bookingHistory"||type==="upcomingBooking"||type==="coupon" ? status : status?.toLocaleLowerCase()}>
                {status}
              </option>
            ))}
          </Form.Select>
        </div>

        {/* Country */}
        {/* <div style={{ minWidth: 150 }}>
          <Form.Label className="fw-semibold text-muted mb-1 d-block">
            Country
          </Form.Label>
          <Form.Select
            size="sm"
            value={body.country || ""}
            onChange={handleCountryChange}
            className="shadow-sm"
            style={{ height: "40px" }}
          >
            <option value="">All</option>
            <option value="Vietnam">Vietnam</option>
            <option value="Thailand">Thailand</option>
          </Form.Select>
        </div> */}

        {/* Region */}
        {/* <div style={{ minWidth: 200 }}>
          <Form.Label className="fw-semibold text-muted mb-1 d-block">
            Region
          </Form.Label>
          <GoogleAutocomplete
            address={debouncedAddress}
            lat={body.lat || ""}
            lng={body.lng || ""}
            onChange={handleRegionChange}
          />
        </div> */}

        {/* Search */}
        <div style={{ minWidth: 200 }}>
          <Form.Label className="fw-semibold text-muted mb-1 d-block">
            {t("common.search")}
          </Form.Label>
          <SearchFilter
            body={body}
            setBody={setBody}
            searchHandler={searchHandler}
            setFinanceSearch={setFinanceSearch}
          />
        </div>
       {type === "bookingHistory" && (
  <div style={{ minWidth: 220, position: "relative" }}>
    <Form.Label className="fw-semibold text-muted mb-1 d-block">
      Date Range
    </Form.Label>

    <div
      className="form-control shadow-sm d-flex align-items-center"
      style={{ height: "40px", cursor: "pointer" }}
      onClick={() => setShowCalendar(!showCalendar)}
    >
      {range?.from && range?.to
        ? `${format(range.from, "yyyy-MM-dd")} - ${format(
            range.to,
            "yyyy-MM-dd"
          )}`
        : "Select date range"}
    </div>

    {showCalendar && (
      <div
        style={{
          position: "absolute",
          zIndex: 999,
          background: "#fff",
          padding: 10,
          borderRadius: 8,
          boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
        }}
      >
        <DayPicker
          mode="range"
          selected={range}
          onSelect={handleRangeSelect}
          numberOfMonths={1}
          disabled={{ after: new Date() }}
        />
      </div>
    )}
  </div>
)}


        {/* Clear Button */}
        <div>
          <Button
            variant="secondary"
            size="sm"
            className="fw-semibold"
            style={{
              height: "38px",
              minWidth: "70px",
              marginTop: "22px",
            }}
            onClick={clearFilters}
          >
            {t("common.clear")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HotelAdminFilter;
